module.exports = (__webpack_require__(2))("./core/touch-emulate/touch-emulate.js");


//////////////////
// WEBPACK FOOTER
// delegated ./core/touch-emulate/touch-emulate.js from dll-reference base
// module id = 102
// module chunks = 22